var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertPoppetje(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 86,
    viewBox: "0 0 96 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3595_6771",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 96,
    height: 86
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.8125,
    width: 94.2113,
    height: 85.3662,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3595_6771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7939 78.6148C42.8339 77.5905 98.4916 71.7895 86.6597 38.4439C85.0533 34.4713 82.5552 30.9358 79.5144 28.0312C82.2307 31.2322 84.5082 34.8219 85.7589 38.7658C96.1345 69.9877 41.3683 75.4023 20.7939 78.6148Z",
    fill: "#4598B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1104 75.0652C78.3571 72.171 96.6633 62.2751 94.9055 45.4062C92.9896 61.4423 77.0336 68.7221 64.1104 75.0652Z",
    fill: "#4598B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9727 55.381C35.921 55.4594 37.8947 55.3533 39.761 55.0026C48.2587 53.4062 52.3378 46.7573 55.1014 42.1272C58.4841 36.4635 60.2211 30.5021 60.3585 24.4705C60.3666 24.091 60.3712 23.7115 60.3712 23.3308C60.3712 6.21739 52.3667 0 38.5311 0C24.6955 0 10.2686 9.01234 10.2686 26.1257C10.2686 32.8934 11.8022 39.9517 16.2832 46.2683C19.6555 51.0219 24.3848 54.8077 33.3479 55.3498C33.5558 55.3625 33.7637 55.3729 33.9727 55.381Z",
    fill: "#FF0533"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1856 11.0742C31.4372 11.0558 30.6784 11.08 29.9613 11.1607C26.6964 11.5264 25.128 13.0479 24.0667 14.1068C22.7663 15.4033 22.0988 16.7679 22.0468 18.1475C22.0433 18.234 22.041 18.3217 22.041 18.4082C22.041 22.3244 25.1176 20.5687 30.4336 20.5687C35.7507 20.5687 41.2942 21.6853 41.2942 17.7692C41.2942 16.22 40.7052 14.6051 38.9833 13.1597C37.6875 12.072 35.8697 11.2057 32.4258 11.0811L32.1856 11.0742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6621 13.5656C10.9138 13.5494 10.155 13.5713 9.43782 13.6429C6.17179 13.9693 4.6046 15.3304 3.54325 16.2775C2.24285 17.4356 1.57532 18.656 1.52335 19.8903C1.51989 19.9675 1.51758 20.046 1.51758 20.1233C1.51758 23.6241 4.5942 21.0795 9.91017 21.0795C15.2273 21.0795 20.7708 23.0532 20.7708 19.5511C20.7708 18.1669 20.1818 16.7227 18.4598 15.4296C17.164 14.4572 15.3462 13.6832 11.9024 13.5725C11.8227 13.569 11.7418 13.5667 11.6621 13.5656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.974 12.7989C34.5351 12.7862 34.0916 12.8035 33.6713 12.8589C31.7587 13.1115 30.8418 14.1646 30.2193 14.8983C29.4582 15.7957 29.0679 16.7392 29.0367 17.6955C29.0344 17.7555 29.0332 17.8155 29.0332 17.8755C29.0332 20.5862 30.8348 21.5713 33.9484 21.5713C37.062 21.5713 40.3084 20.1444 40.3084 17.4325C40.3084 16.3609 39.9631 15.2432 38.9549 14.2419C38.1961 13.4898 37.1313 12.89 35.1149 12.8035C35.0675 12.8023 35.0213 12.8 34.974 12.7989Z",
    fill: "#140E17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2644 13.7944C38.0969 13.7898 37.926 13.7956 37.7655 13.8175C37.0333 13.9144 36.6822 14.317 36.4431 14.5984C36.1521 14.9422 36.0031 15.3032 35.9904 15.67L35.9893 15.7381C35.9893 16.7763 36.6799 17.1535 37.8717 17.1535C39.0636 17.1535 40.3074 16.6067 40.3074 15.5685C40.3074 15.159 40.1746 14.7299 39.7889 14.347C39.4978 14.0586 39.0901 13.8291 38.3187 13.7968C38.3002 13.7956 38.2829 13.7944 38.2644 13.7944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1458 12.9336C11.707 12.921 11.2635 12.9383 10.8431 12.9936C8.93062 13.2462 8.01365 14.2994 7.39116 15.033C6.63009 15.9304 6.23973 16.8752 6.20855 17.8303C6.20623 17.8903 6.20508 17.9502 6.20508 18.0102C6.20508 20.721 8.00671 21.706 11.1203 21.706C14.2339 21.706 17.4803 20.2792 17.4803 17.5673C17.4803 16.4957 17.135 15.3779 16.1268 14.3767C15.368 13.6246 14.3032 13.0248 12.2867 12.9383C12.2394 12.9371 12.1932 12.9348 12.1458 12.9336Z",
    fill: "#140E17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4373 13.9312C15.2698 13.9266 15.0989 13.9323 14.9383 13.9542C14.2061 14.0511 13.8551 14.4537 13.616 14.7352C13.325 15.0789 13.176 15.44 13.1633 15.8068L13.1621 15.8748C13.1621 16.913 13.8527 17.2902 15.0446 17.2902C16.2364 17.2902 17.4803 16.7434 17.4803 15.7053C17.4803 15.2958 17.3474 14.8667 16.9617 14.4837C16.6707 14.1953 16.263 13.9658 15.4915 13.9335C15.4731 13.9323 15.4557 13.9312 15.4373 13.9312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7364 76.8031C34.1267 67.4401 34.1752 57.6676 34.2237 48.2734H33.249C33.2975 57.6745 33.3426 67.4332 33.7364 76.8031ZM33.7364 76.8031C34.1302 67.4401 34.1752 57.6676 34.2237 48.2734H33.249C33.2975 57.6745 33.346 67.4332 33.7364 76.8031Z",
    fill: "#00819B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9794 51.5117C36.3118 55.8247 36.3061 60.1526 36.9794 64.4667C37.6527 60.1526 37.6469 55.8247 36.9794 51.5117Z",
    fill: "#00819B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertPoppetje);
export default __webpack_public_path__ + "static/media/alert-poppetje.485c78b7db0d3025b1ca098185c1f5c2.svg";
export { ForwardRef as ReactComponent };